import { eTipoPermissao } from '@/enums/ePermissoes';
import Index from '@/views/biblioteca/bibemprestimo/Index.vue';
import GridIndex from '@/views/biblioteca/bibemprestimo/components/GridIndex.vue';
export default [
    {
        description: 'Emprestimo Documento Escola',
        path: '/biblioteca/bibemprestimousuario/1',
        alias: '/biblioteca/bibemprestimo/1',
        name: 'bibemprestimoescola',
        component: Index,
        meta: {
            permissions: [eTipoPermissao.BIB_EMPRESTIMOESCOLANOVO_MENU_1300400399],
        },
        goesToMenu: true,
    },
    {
        description: 'Emprestimo Documento Central',
        path: '/biblioteca/bibemprestimousuario/0',
        alias: '/biblioteca/bibemprestimo/0',
        name: 'bibemprestimocentral',
        component: Index,
        meta: {
            permissions: [eTipoPermissao.BIB_EMPRESTIMOCENTRALNOVO_MENU_1300400359],
        },
        goesToMenu: true,
    },
    {
        description: 'Emprestimo de Exemplar Escola',
        path: '/biblioteca/bibemprestimousuario/emprestimo/1/:bibTipoUsuarioId/:segUsuarioId',
        parent: 'bibemprestimoescola',
        name: 'bibemprestimo_grid_escola',
        component: GridIndex,
        meta: {
            permissions: [eTipoPermissao.BIB_EMPRESTIMOESCOLANOVO_MENU_1300400399],
        },
        goesToMenu: false,
    },
    {
        description: 'Emprestimo de Exemplar Central',
        path: '/biblioteca/bibemprestimousuario/emprestimo/0/:bibTipoUsuarioId/:segUsuarioId',
        parent: 'bibemprestimocentral',
        name: 'bibemprestimo_grid_central',
        component: GridIndex,
        meta: {
            permissions: [eTipoPermissao.BIB_EMPRESTIMOCENTRALNOVO_MENU_1300400359],
        },
        goesToMenu: false,
    },


]
